//@flow
import React from "react";

export default function colorPill(value: string | number, bkgColor: string, textColor: string) {
  if (!bkgColor) bkgColor = "very-light-pink-two";
  if (!textColor) textColor = "black";

  return (
    <div title={value} className={`gs-badge text-color-${textColor} background-color-${bkgColor}`}>
      {value}
    </div>
  );
}
